import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive } from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { OperatorService } from '../../services/operator.service';
import { NotificationService } from '../../services/notification.service';
import { LoadingService } from '../../services/util/loading.service';
const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};
declare const swal: any;

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html',
    // styleUrls: ['../../../assets/css/health.css']
})

export class NavbarComponent implements OnInit {
    operatorId: any;
    operatorRoles: any[] = [];

    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    educationalCentersHasOperator: any[] = [];
    educationalCenters: any[] = [];
    educationalCenterLevel: any[] = [];
    notifications: any[] = [];
    read = false;
    notData = false;
    generalInfo: any = {};

    @ViewChild('app-navbar-cmp') button: any;
    reply: any = '';
    count: any = 0;
    replyShow: boolean = false;
    details: any;
    operatorIsTeacher: any;

    constructor(location: Location, private renderer: Renderer, private router: Router, private element: ElementRef,
        private notificationService: NotificationService,
        private loadingService: LoadingService,
        private operatorService: OperatorService) {
        this.operatorRoles = JSON.parse(localStorage.getItem('operatorRoles')) ? JSON.parse(localStorage.getItem('operatorRoles')) : [];
        const systemOwner = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).authToken.claims.scopes.systemOwner : false;
        const operatorId = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).person.operatorId : 0;
        if (!systemOwner && operatorId > 0) {
            this.operatorService.getRolesByOperatorId(operatorId).subscribe((response: any) => {
                const oRoles = JSON.stringify(response);
                localStorage.setItem('operatorRoles', oRoles);
            });
        }
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
        this.educationalCentersHasOperator = JSON.parse(localStorage.getItem('educationalCenters')) ? JSON.parse(localStorage.getItem('educationalCenters')) : null;
    }

     containRole(role:any) {
        return this.operatorService.containRole(this.operatorRoles, role);
    }

    ngOnInit() {
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        this.getOperatorIsTeacher();
        this.getUnreadNotifications();
        setInterval(() => {
            this.getUnreadNotificationsAlert();
        }, 7200000);

        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        if ($('body').hasClass('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if ($('body').hasClass('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        $('#minimizeSidebar').click(function () {
            if (misc.sidebar_mini_active === true) {
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;

            } else {
                setTimeout(function () {
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);
        });
        $('#hideSidebar').click(function () {
            if (misc.hide_sidebar_active === true) {
                setTimeout(function () {
                    $('body').removeClass('hide-sidebar');
                    misc.hide_sidebar_active = false;
                }, 300);
                setTimeout(function () {
                    $('.sidebar').removeClass('animation');
                }, 600);
                $('.sidebar').addClass('animation');

            } else {
                setTimeout(function () {
                    $('body').addClass('hide-sidebar');
                    // $('.sidebar').addClass('animation');
                    misc.hide_sidebar_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);
        });
    }

    getUnreadNotifications() {
        this.notificationService.getUnreadNotifications().subscribe((response: any) => {
            if (response.length > 0) {
                this.notData = false;
                this.notifications = response;
                this.notificationService.setUnreadNotificationsCount(response);
            } else {
                this.notData = true;
                this.notificationService.setUnreadNotificationsCount(response);
            }
        });
    }

    getUnreadNotificationsAlert() {
        this.notificationService.getUnreadNotifications().subscribe((response: any) => {
            if (response.length > 0) {
                this.notData = false;
                this.notifications = response;
                this.notificationService.setUnreadNotificationsCountAlert(response);
            } else {
                this.notData = true;
                this.notificationService.setUnreadNotificationsCountAlert(response);
            }
        });
    }

    isMobileMenu() {
        if ($(window).width() < 991) {
            return false;
        }
        return true;
    };

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');

        this.sidebarVisible = true;
    };

    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    };

    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };

    getTitle() {
        const titlee: any = this.location.prepareExternalUrl(this.location.path());
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === 'link' && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === 'sub') {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    const subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        return '';
    }

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }

    lastDateLogin(operatorId: any) {
        const operator: any = {};
        operator.id = operatorId;
        this.operatorService.lastDateLogin(operator).subscribe();
    }

    onSelectEducationalCenter() {
        const operatorId = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).person.operatorId : null;
        if (operatorId !== null) {
            this.lastDateLogin(operatorId);
            this.operatorService.getEducationalCenters(operatorId).subscribe((response: any) => {
                this.educationalCenters = [];
                this.educationalCenterLevel = [];
                this.educationalCenters = response;
                this.educationalCenters.forEach((educationalCenter: any) => {
                    if (educationalCenter.level) {
                        educationalCenter.level.forEach((level: any) => {
                            const educationalCenterLevel = {
                                id: educationalCenter.id,
                                name: educationalCenter.name,
                                epda: educationalCenter.epda,
                                selfManaged: educationalCenter.selfManaged,
                                generative: educationalCenter.generative,
                                private: educationalCenter.private,
                                level: level
                            };
                            this.educationalCenterLevel.push(educationalCenterLevel);
                        });
                    }
                });
            });
        }
    }

    changeHealthCenter(educationalCentersHasOperator: any) {
        localStorage.setItem('educationalCenters', JSON.stringify(educationalCentersHasOperator));
        }

    goNotifications() {
        this.router.navigateByUrl('/notifications');
    };

    getInfoNotification(row: any, i: any) {
        this.generalInfo = {};
        this.notifications.splice(i, 1);
        this.notData = this.notifications.length === 0 ? true : false;
        const notis = [];
        notis.push(row.id);
        this.notificationService.readNotifications(notis).subscribe();
        this.notificationService.getDetaillNotifications(row.id).subscribe((response: any) => {
            this.details = null;
            this.clearModal();
            if(response){                
                this.details = response;
                this.generalInfo = response
                this.generalInfo.status = 'REA';
            }else{
                swal({
                    title: 'Atención!',
                    text: 'Ocurrió un problema al obtener los detalles',
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            }           
        }, (error: any) => {
            this.notData = true;
            if (error.status === 409) {
                swal({
                    title: 'Atención!',
                    text: JSON.parse(error._body).message,
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            } else {
                swal({
                    title: 'Atención!',
                    text: 'Ocurrió un problema al obtener los detalles',
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            }
        });
        //this.generalInfo = row;
        
        $('#generalInfoNotifications').modal('show');
    }

    getNotificationsCount() {
        this.notifications = this.notificationService.getUnreadNotificationsCount();
        return this.notifications.length;
    };

    setStyles(row: any) {
        const styles = {
            'border-left': '5px solid' + row.color
        };
        return styles;
    }

    addReply(e: any){
        if (e.target.value.length > 2000) {
            this.dialog('Solo se guardara una "Respuesta" de 2000 o menos caracteres');
            e.target.value = this.reply;
        }
        else {
        this.reply = e.target.value
        }
        this.count = e.target.value.length;
    }

    showReply(){
        this.replyShow = true;
    }

    dialog(msg: string) {
        $.notify({
            icon: 'notifications',
            message: msg
        }, {
                type: 'rose',
                timer: 3000,
                placement: {
                    from: 'top',
                    align: 'center'
                }
            });
    }

    sendReply(id:number){
        let body:any = {};
        if(this.reply && this.reply.length > 0){
            body.text = this.reply
        }
        this.loadingService.enableShowSpinner();
        this.notificationService.postCreateResponse( id, body).subscribe((response: any) => {
            if(response){                
                $('#generalInfoNotifications').modal('hide');
                swal({
                    title: 'Enviado!',
                    text: 'Se envio la respuesta exitosamente.',
                    type: 'success',
                    confirmButtonColor: '#b8465e'                  
                  }); 
            }else{
                swal({
                    title: 'Atención!',
                    text: 'Ocurrió un problema al obtener los detalles',
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            }
            this.loadingService.disableShowSpinner(); 
           
        }, (error: any) => {
            this.notData = true;
            if (error.status === 409) {
                swal({
                    title: 'Atención!',
                    text: JSON.parse(error._body).message,
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            } else {
                swal({
                    title: 'Atención!',
                    text: 'Ocurrió un problema al obtener los detalles',
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            }
        });
    }

    clearModal(){
        this.replyShow = false;
        this.reply = '';
    }

    downloadFile(fileId:number){
        this.notificationService.getDownloadFiles(fileId).subscribe((response: any) => {
          const linkSource = response.document;
          const downloadLink = document.createElement("a");
          const fileName = response.name;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();    
        }, (error: any) => {
            this.notData = true;
            if (error.status === 409) {
                swal({
                    title: 'Atención!',
                    text: JSON.parse(error._body).message,
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            } else {
                swal({
                    title: 'Atención!',
                    text: 'Ocurrió un problema al obtener los detalles',
                    type: 'warning',
                    confirmButtonColor: '#b8465e'
                });
            }
        });
    }

    public getOperatorIsTeacher() {
        this.operatorIsTeacher = JSON.parse(localStorage.getItem('educationalCenters')) ?
            JSON.parse(localStorage.getItem('educationalCenters')).operatorIsTeacher : '';
    }
    
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/shared/navbar/navbar.component.ts